import * as _4 from 'lodash4';
angular.module('data-ng-personal-reminders').directive('expandText', function expandText() {
  return {
    replace: false,
    restrict: 'A',
    scope: false,
    link: function linkerFn(scope, element, attrs) {
      const textarea = angular.element(element[0]);
      textarea.bind('input', () => {
        textarea.css('height', 'auto');
        textarea.css('height', +_4.first(textarea).scrollHeight + 'px');
      });
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/data-ng-personal-reminders/src/components/expanding_reminder_textbox/expanding_textbox_directive.ts